(function () {

  var heartbeatDuration = {0: 5, 1: 12, 12: 15, 18: 30};
  var bufferingHeartbeatDuration = {0: 5, 1: 10, 5: 60};

  var currentMedia = {};
  var currentTime = 0;
  var startTime, playTime;
  var tag;

  /**
   *
   * @param {CustomEvent} event
   * @private
   */
  var _handleMediaChange = function _handleMediaChange(event) {
    if (!event.detail.currentMedia.hasOwnProperty('mediaId')) {
      return;
    }

    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    console.debug('Tracking PIANO Audioplayer `mediaChange`');

    var instance = event.detail.plyr;
    currentMedia = event.detail.currentMedia;

    if ('undefined' !== typeof tag && 'stop' !== instance.action) {
      console.debug('Tracking PIANO Audioplayer: Force end of current playback')
      instance.action = 'stop';
      if (true === currentMedia.isLive) {
        tag.playbackStopped(playTime);
      } else {
        currentTime = instance.currentTime * 1000
        tag.playbackStopped(currentTime);
      }
    }

    try {
      console.debug('Tracking PIANO Audioplayer: initialize a new `pa.avInsights.Media` Object');
      tag = new pa.avInsights.Media(heartbeatDuration, bufferingHeartbeatDuration);
    } catch (exception) {
      (console.error || console.log).call(console, exception.stack || exception)
      return;
    }

    tag.set('av_content_type', 'Audio');
    tag.set('av_institution', 'SWR');
    tag.set('av_content_id', currentMedia.mediaId);
    tag.set('av_content', currentMedia.title);
    tag.set('av_broadcasting_type', (true === currentMedia.isLive) ? 'Live' : 'On Demand');
    if (true !== currentMedia.isLive) {
      tag.set('av_content_duration', currentMedia.duration * 1000);
      tag.set('av_show', (null !== currentMedia.mediaTheme2 ? currentMedia.mediaTheme2 : '_'));
      if (null !== currentMedia.publicationDate) {
        tag.set('av_publication_date', currentMedia.publicationDate);
      }
    }
    tag.set('av_broadcaster', (null !== currentMedia.mediaTheme1 ? currentMedia.mediaTheme1 : '_'));
    tag.set('av_launch_reason', 'Klick');
  };

  /**
   *
   * @param {CustomEvent} event
   * @private
   */
  var _handlePlayerReady = function _handlePlayerReady(event) {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    var instance = event.detail.plyr;

    if ('ended' === instance.oldState && 'ended' === instance.newState &&  null === instance.isBuffering && null === instance.action) {
      return;
    }

    console.debug('Tracking PIANO Audioplayer `ready`');

    instance.oldState = 'ended';
    instance.newState = 'ended';
    instance.isBuffering = null;
    instance.action = null;
  }

  /**
   *
   * @param {CustomEvent} event
   * @private
   */
  var _handlePlayerPlay = function _handlePlayerPlay(event) {
    if (!tag) {
      return;
    }

    console.debug('Tracking PIANO Audioplayer `play`');

    var instance = event.detail.plyr;

    if ('stop' === instance.action) {
      instance.action = null;
    }

    if (null === instance.action) {
      currentTime = instance.currentTime * 1000
      tag.play(currentTime);
      tag.bufferStart(currentTime);
    }
  }

  /**
   *
   * @param {CustomEvent} event
   * @private
   */
  var _handlePlayerPlayingPauseEnded = function _handlePlayerPlayingPauseEnded(event) {
    if (!tag) {
      return;
    }

    console.debug('Tracking PIANO Audioplayer `playing`, `pause`, `ended`');

    var instance = event.detail.plyr;

    var readyState = instance.readyState;
    var networkState = instance.networkState;
    if (networkState < 1 || readyState < 1) {
      return;
    }
    instance.oldState = instance.newState;
    instance.newState = event.detail.originalEvent.type;
    if ((readyState < 4) && ('playing' === instance.newState) && ('buffering' !== instance.oldState)) {
      instance.newState = 'buffering';
      currentTime = instance.currentTime * 1000
      tag.bufferStart(currentTime);
    }

    if ('buffering' === instance.oldState) {
      instance.isBuffering = false;
    } else if ('buffering' === instance.newState) {
      instance.isBuffering = true;
    } else {
      instance.isBuffering = null;
    }

    switch (instance.newState + instance.oldState) {
      case 'bufferingended':
      case 'bufferingpause':
      case 'playingended':
      case 'playingpause':
        instance.action = 'play';
        break;
      case'playingbuffering':
      case'bufferingplaying':
        instance.action = 'info';
        break;
      case'pauseplaying':
      case'pausebuffering':
        instance.action = 'pause';
        break;
      case'endedplaying':
      case'endedpause':
      case'endedbuffering':
        instance.action = 'stop';
        break;
      default:
        break;
    }

    if ('play' === instance.action && 0 !== instance.currentTime) {
      instance.action = 'resume';
    }

    switch (instance.action) {
      case 'play':
        if (true === currentMedia.isLive) {
          startTime = new Date().getTime();;
          currentTime = 0
        } else {
          currentTime = instance.currentTime * 1000
        }
        tag.playbackStart(currentTime);
        break;
      case 'resume':
        if (true === currentMedia.isLive) {
          startTime = new Date().getTime();;
          currentTime = 0
          tag.playbackStart(currentTime);
        } else {
          currentTime = instance.currentTime * 1000
          tag.playbackResumed(currentTime);
        }
        break;
      case 'pause':
        if (true === currentMedia.isLive) {
          var endTime = new Date().getTime();;
          playTime = endTime - startTime;
          tag.playbackPaused(playTime);
        } else {
          currentTime = instance.currentTime * 1000
          tag.playbackPaused(currentTime);
        }
        break;
      case 'stop':
        if (true === currentMedia.isLive) {
          tag.playbackStopped(playTime);
        } else {
          currentTime = instance.currentTime * 1000
          tag.playbackStopped(currentTime);
        }
        break;
      default:
        break;
    }
  }

  document.addEventListener('audioplayer:medium_change', _handleMediaChange);

  document.addEventListener('audioplayer:ready', _handlePlayerReady);

  document.addEventListener('audioplayer:play', _handlePlayerPlay);

  document.addEventListener('audioplayer:playing', _handlePlayerPlayingPauseEnded);
  document.addEventListener('audioplayer:pause', _handlePlayerPlayingPauseEnded);
  document.addEventListener('audioplayer:ended', _handlePlayerPlayingPauseEnded);

})();
